// @ts-strict-ignore
import { getUniqueNamesFromActions } from 'flow/service/actions';
import type { BaseAddActionOptionType } from './types';
import type { WorkflowState } from '~/dashboard/views/workflows/store/redux/state';

/**
 * Helper that maps an array of elements to Options.
 * This helper supports params to create any Option that extends from
 * `BaseAddActionOptionType`
 */
export function formatCreatableElementsAsOptions<
  O extends BaseAddActionOptionType, T,
>({
  shouldNotDisableOptions,
  elementActionsInWorkflow,
  creatableElements,
  optionMapper,
}: {
  /** array of items to create (services, outcome reasons, etc) */
  creatableElements: T[];
  /** array of actions that already exist in the workflow for supplied type of element */
  elementActionsInWorkflow: WorkflowState['workflowData']['actions'][string][];
  /**
   * function that maps an element to an Option or array of Options of type `O` without a disabled key
   * */
  optionMapper: (e: T) => Omit<O, 'disabled'> | Omit<O, 'disabled'>[];
  /** we want to allow duplicate services
   * todo BUILD-2581: refactor this into a function instead
  */
  shouldNotDisableOptions?: boolean;
}): O[] {
  if (!creatableElements) {
    return [];
  }
  const uniqueElementActionNames = getUniqueNamesFromActions(elementActionsInWorkflow);
  return creatableElements
    .flatMap(e => {
      // the mapper is not concerned with figuring out if the option should be disabled or not
      const optionWithoutDisabled = optionMapper(e);
      const arr = Array.isArray(optionWithoutDisabled)
        ? optionWithoutDisabled
        : [optionWithoutDisabled];

      return arr.map(option => ({
        ...option,
        disabled: !shouldNotDisableOptions && uniqueElementActionNames.has(option.meta.name),
      } as O));
    })
    .sort((a, b) => a.label.localeCompare(b.label));
}
